import { computed } from 'mobx';

import type { IBaseAttributes } from '@feathr/rachis';
import { Collection, Model } from '@feathr/rachis';

export type TTagContext = 'account' | 'event' | 'partner' | 'person' | 'person_segment';

export interface ITag extends IBaseAttributes {
  name: string;
  context?: TTagContext;
}

export class Tag extends Model<ITag> {
  public readonly className = 'Tag';

  public constraints = {
    name: {
      length: {
        maximum: 64,
        tooLong: '^Tag name must be less than 64 characters in length.',
      },
    },
  };

  @computed
  public get name() {
    return this.get('name', '').trim() || 'Unnamed Tag';
  }
}

export class Tags extends Collection<Tag> {
  public getClassName() {
    return 'tags';
  }

  public getModel(attributes: Partial<ITag>) {
    return new Tag(attributes);
  }
}
